import React from 'react';
import PatientQueue from './PatientQueue';

const UnverifiedQueue = () =>
    <PatientQueue
	    showQueueCount
	    showFilters
		showScheduleCallFilter
        patientDetailColumn
        providerDetailColumn
        actionsColumn
        page
        lastOutCallColumn
        lastHistoryColumn
		callAttemptsCol
		reengageFilter
		reengageIndicator
        queue="unverified"
        endpoint="Unverified"
        label="Unverified"
	    showSort
	    sortOptions={[
		    {
		    	'name': 'Last Called Ascending',
			    'key': 'lastOutCallTs&dir=asc',
		    },
		    {
			    'name': 'Last Called Descending',
			    'key': 'lastOutCallTs&dir=desc',
		    }
	    ]}
    />;

export default UnverifiedQueue;
